module.exports = __webpack_public_path__ + "cfa862467d696e4a9e1e870da6edca19.pdf";